import State from '../core/State';

export const addNonFatalError = (error: Error) => (state: State): State => ({
  ...state,
  nonFatalErrors: state.nonFatalErrors.concat(error),
});

export const removeNonFatalError = (error: Error) => (state: State): State => ({
  ...state,
  nonFatalErrors: state.nonFatalErrors.filter(err => err !== error),
});
